(function() {
    'use strict';

    angular
        .module('atheer.anchor', [

        ]);
})();
